<template>
  <div>
    <v-card class="mb-5">
      <v-layout row wrap justify-center>
        <v-flex
          v-for="(item, index) in columbus_process"
          :key="`extrac_process_${index}`"
          mb-3
          mr-2
          ml-2
          xs6
          sm4
          md3
          lg2
        >
          <v-card :href="item.url" :target="item.target">
            <v-img :src="`${item.image}`" height="150px" contain> </v-img>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex
          v-for="(item, index) in other_process"
          :key="`extrao_process_${index}`"
          mb-3
          mr-2
          ml-2
          xs6
          sm4
          md3
          lg2
        >
          <v-card :href="item.url" :target="item.target">
            <v-img :src="`${item.image}`" height="100px" contain> </v-img>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
    <v-layout
      v-if="enrollment_status.current_step !== 0"
      justify-center
      row
      wrap
    >
      <v-btn flat @click="goToPrevStep">Atrás</v-btn>
      <v-btn v-if="hasSurvey" color="primary" @click="HandleGoToNextStep">
        Siguiente
      </v-btn>
      <v-btn v-else color="primary" @click="finishEnrollmentProcess()">
        Finalizar matrícula
      </v-btn>
    </v-layout>
    <v-layout v-else justify-center row wrap>
      <v-btn flat @click="$emit('goToPrevStep', 1)">{{
        $t(`enrollments.back`)
      }}</v-btn>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
export default {
  name: "enrollment-step-6",
  components: {},
  props: {
    system_access: {
      type: Boolean,
      default: false
    },
    hasSurvey: {
      type: Boolean,
      default: false
    },
    isEnrollmentSurvey: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      extra_process: [],
      appUrl: window.config.appUrl
    };
  },
  computed: {
    ...mapGetters({
      enrollment_id: "currentEnrollmentId",
      enrollment_status: "currentEnrollment",
      student: "currentEnrollmentStudent"
    }),
    columbus_process() {
      return this.extra_process.filter(
        process => process.status == 1 && process.company == 1
      );
    },
    other_process() {
      return this.extra_process.filter(
        process => process.status == 1 && process.company != 1
      );
    }
  },
  created() {
    this.init();
  },
  methods: {
    HandleGoToNextStep() {
      this.$emit("goToNextStep", !this.isEnrollmentSurvey ? 7 : 8);
      this.finishEnrollmentProcess();
    },
    async init() {
      const allies = await axios.get("/api/enrollments/allies");
      this.extra_process = allies.data;
      console.log("isEnrollmentSurvey", this.isEnrollmentSurvey);
    },
    goToPrevStep() {
      const prevStep = this.hasSurvey && !isEnrollmentSurvey ? 7 : 6;
      this.$emit("goToPrevStep", prevStep);
    },
    async finishEnrollmentProcess() {
      const { data } = await axios.get(
        `/api/enrollment/start/finishEnrollmentProcess/${this.enrollment_id}/${this.student.id}`
      );
      if (data.response) {
        const payload = {
          enrollment_id: this.enrollment_id,
          student_id: this.student.id
        };
        await this.$store.dispatch("fetchEnrollmentStatus", payload);
        this.$store.dispatch("responseMessage", {
          type: "success",
          title: this.$t("enrollments.start.finish-enrollment-process-title"),
          text: this.$t("enrollments.start.finish-enrollment-process-text"),
          modal: false
        });
        this.$emit('goToPrevStep', 1)
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// resources/assets/js/pages/enrollment/enrollment_step6.vue